import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    Grid,
    TextField,
    FormControl,
    Button,
    MenuItem,
    List,
    ListItem,
    ListItemText,
    Select,
    ListItemIcon,
    Paper,
    Box,
    Checkbox,
    Card,
    CardHeader,
    Divider,
    InputBase,
    IconButton

} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useStyles } from '../../styles/style';
import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { content_type, tags, operators, fields, name as radioList } from './objects';
import BucketQuery from './bucketQuery';
import BucketForm from './bucketForm';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import NoImage from './../../images/no_image.png'
import cogoToast from 'cogo-toast';
import { ContactSupportOutlined } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import { ReactTransliterate } from "react-transliterate";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import MultiLanguageModal from '../Reusable/multiLanguageModal';
import CloseIcon from '@material-ui/icons/Close';
import { game_content_type } from './objects'

function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
    return [...a, ...not(b, a)];
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function EditBucket(props) {
    const classes = useStyles();
    const initialState = {
        row: "",
        size: "",
        enable: "true",
        more: "true",
        magnification:1,
        shortDescription:"",
        url:"",
        proUser:""
    }

    const theme = useTheme();
    const textRef = useRef();
    const [tag, setTag] = useState([]);
    const [initialValues, setInitialValues] = useState(initialState)
    const [liveDate, setLiveDate] = useState(new Date());
    const [expiryDate, setExpiryDate] = useState(new Date());
    const [media, setMedia] = useState();
    const [option1, setOption1] = useState(fields[0]);
    const [option2, setOption2] = useState("Equal");
    const [option3, setOption3] = useState("");
    const [text, setText] = useState("");
    const [query, setQuery] = useState([]);
    const [bucketStyle, setBucketStyle] = useState("1");
    const [modal, setModal] = useState(false);
    const [englishLang,setEnglishLang] = useState("");
    const [hindiLang, setHindiLang] = useState("");
    const [marathiLang, setMarathiiLang] = useState("");
    const [kannadaLang, setKannadaLang] = useState("");
    const [teluguLang, setTeluguLang] = useState("");
    const [punjabiLang, setPunjabiLang] = useState("");
    const [tamilLang, setTamilLang] = useState("");
    const [gujaratiLang, setGujaratiLang] = useState("");

    const [malayalamLang, setMalayalamLang] = useState("");
    const [bengaliLang, setBengaliLang] = useState("");
    const [odisaLang, setOdisaLang] = useState("");
    const [urduLang, setUrduLang] = useState("");
    const [sinhalaLang, setSinhalaLang] = useState("");
    const [khmerLang, setKhmerLang] = useState("");
    const [arabicLang, setArabicLang] = useState("");
    const [burmeseLang, setBurmeseLang] = useState("");
    const [afganiLang, setAfganiLang] = useState("");
  const [dariLang, setDariLang] = useState("");
    const [pashtoLang, setPashtoLang] = useState("");
    const [vietnameseLang, setVietnameseLang] = useState("");
    const [andOr, setAndOr] = useState([]);
    const [pages, setPages] = useState([]);
    const [singlePage, setSinglePage] = useState('60bb7637d481516c2cf7cf6e')
    const [queryResult, setQueryResult] = useState([]);
    const [leftData, setLeftData] = useState([]);
    const [checked, setChecked] = React.useState([]);
    const [varient, setVarient] = React.useState("v1");
    const [langList, setLangList] = useState([{ code: "Default", name: "Default" }])
    const [lang, setLang] = useState([])
    const [deleteMediaList, setDeleteMediaList] = useState([]);
    const [searched, setSearched] = useState("")
    const [content, setContent] = useState("")
    const [continueToggle, setcontinueToggle] = useState()
    const [proToggle, setproToggle] = useState()

    let mainData = [];
    const varientArray = ["none","v1", "v2", "v3", "v4", "v5", "v6"]
    const bucketSTyleList = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14"];

    const queryContentType = content_type.filter(ele=>{
        return ele.Description != "charts"
    })

    const handleContentChange = (e)=>{
        setContent(e.target.value);
    }

    const fetchBucketByID = async () => {
        let data = localStorage.getItem("storeId");
        await axios.get(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/${props.match.params.id}?storeId=${data}`)
            .then(
                res => {
                    let name = JSON.parse(res.data.result.result.names)
                    setInitialValues({
                        row: res.data.result.result.row,
                        size: res.data.result.result.size,
                        enable: res.data.result.result.enabled.toString(),
                        more: res.data.result.result.more.toString(),
                        magnification:res.data.result.result.magnification?res.data.result.result.magnification:1,
                        shortDescription:res.data.result.result.shortDescription,
                        url:res.data.result.result.url,
                        proUser:res.data.result.result.proUser
                    })
                    let query = JSON.parse(res.data.result.result.query)
                    
                    console.log('<==>',query);
                    setQuery(query)
                    setBucketStyle(res.data.result.result.bucketStyle);
                    setMedia(res.data.result.result.media === null? "":res.data.result.result.media)
                    setHindiLang(name[0].hi ? name[0].hi : '');
                    setMarathiiLang(name[0].mr ? name[0].mr : '');
                    setKannadaLang(name[0].kn ? name[0].kn : '');
                    setTeluguLang(name[0].te ? name[0].te : '');
                    setPunjabiLang(name[0].pa ?name[0].pa  : '');
                    setTamilLang(name[0].ta ? name[0].ta : '');
                    setGujaratiLang(name[0].gu ? name[0].gu : '');
                    setKhmerLang(name[0].khm ? name[0].khm : '')
                    setEnglishLang(name[0].en ? name[0].en : '');
                    setMalayalamLang(name[0].ml ? name[0].ml : '');
                    setOdisaLang(name[0].or ? name[0].or : '');
                    setUrduLang(name[0].ur ? name[0].ur :'' );
                    setBengaliLang(name[0].bn ? name[0].bn :'' );
                    setDariLang(name[0].prs ? name[0].prs : '');
                    setPashtoLang(name[0].ps ? name[0].ps : '');
                    setVietnameseLang(name[0].vi ? name[0].vi : '');
                    setcontinueToggle(res.data.result.result.continueStatus ? res.data.result.result.continueStatus : false);
                    setproToggle(res.data.result.result.proUser ? res.data.result.result.proUser : false);
                    let tag = res.data.result.result.tag
                    let tags = [];
                    for (let index = 0; index < tag.length; index++) {
                        if(tag[index]!= ''){
                            tags.push(tag[index])
                        }
                    }
                    setTag(tags)
                    if(res.data.result.result.live_date_time){
                        setLiveDate(res.data.result.result.live_date_time)
                     }else{
                         setLiveDate(null)
                        }
                        if(res.data.result.result.expiry){
                            setExpiryDate(res.data.result.result.expiry)
                         }else{
                            setExpiryDate(null)
                            }

                   
                    setLang(res.data.result.result.language)
                    let QueryData = JSON.parse(res.data.result.result.queryData)

                    let newQueryData = QueryData.map(ele => {
                        let obj = {
                            id: ele.id,
                            eventName: ele.eventName,
                            // defaultVarient: ele.varient,
                            image: ele.image,
                            sequence: ele.sequence,
                            // varient: varientArray
                        }
                        return obj

                    })          
                    mainData =newQueryData    
                    // for(let i in newQueryData){
                    // for (let j in preData){
                    //     if(newQueryData[i].id != preData[j].id){
                    //         newQueryData[i].notExists = true
                    //     }
                    //     else{
                    //         newQueryData[i].notExists = true
                    //     }
                    console.log('main data',mainData)
                          setLeftData(mainData)
                // }
                // }
                    setSinglePage(res.data.result.result.page)
                    setContent(res.data.result.result.contentType)
                   
                    let and_or = query.map((ele,i)=>{
                        let abc = {
                            AND_OR:ele.AND_OR
                        }
                        return abc
                    })
                    setAndOr(and_or)
                    let latestQuery = query
                    var typeStatus = latestQuery.map( i =>{ 
                       if(i.field.value && i.field.value.includes("typeid")){
                            return true
                          }
                })
                typeStatus = typeStatus.filter(i=> i !=undefined)
                let type = res.data.result.result.contentType
                if(typeStatus[0] == true){
                let temp_query = JSON.parse(JSON.stringify(QueryData))
                let New_Query= temp_query.map(e =>{
                    let split =  e.id.split('-')
                    console.log(split)
                    if(split.length ==2){
                        e.id = split[1]
                    }
                    return e.id
                }).join();
                latestQuery = latestQuery.map(i =>{
                    if(i.field.value && i.field.value.includes("contentId") && typeStatus[0]){
                        i.text = New_Query
                    }
                    return i 
                })
                postQuery_new()
                //  onSerachQuery2(latestQuery,type);
            }
            else{
                postQuery_new()
                // onSerachQuery2(query,type);
            }
                    
                }
            ).catch(
                err => {
                    console.log(err)
                }
            )

    }


    const fetchLanguage = async () => {
        await axios.get(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/type/language?storeId=${localStorage.getItem("storeId")}`).then(res => {
            setLangList([...langList, ...res.data.result.result])
        }).catch(
            err => {
                console.log(err)
            }
        )
    }

    const handleChangeLang = (e) => {
        setLang(e.target.value)
    }

    const fetchPages = async () => {
        let data = localStorage.getItem("storeId");
        const url = process.env.REACT_APP_CMS_CONTENT_IP
        await axios.get(`${url}/v1/content/type/page?storeId=${data}`).then(res => {
            setPages(res.data.result.result)
        }).catch(
            err => {
                console.log(err)
            }
        )
    }


    useEffect(() => {
        fetchBucketByID();
        fetchLanguage();
        fetchPages()
        // postQuery_new()
    }, [])

    const onHandleChangeData = (e) => {
        const value = e.target.value;
        setInitialValues({
            ...initialValues,
            [e.target.name]: value
        })

    }


    const handleTagChange = (event) => {
        setTag(event.target.value);
    };

    const onLiveDateChange = (e) => {
        setLiveDate(e)
    }
    const onexpiryDateChange = (e) => {
        setExpiryDate(e)
    }

    const medialHandle = (e) => {
        setMedia([...media, ...e.target.files]);
        // changeMedia(e.target.files)

    }

    const handlePageChange = (event) => {
        setSinglePage(event.target.value);
    }


    const optionOneHandleChange = (e) => {
        setOption1(e.target.value);
        setText("");

    }

    // useEffect(() => {
    //     if (option1) {
    //         textRef.current.focus()
    //     }

    // }, [option1])

    const optionTwoHandleChange = (e) => {
        setOption2(e.target.value)
    }

    const optionThreeHandleChange = (e) => {
        setOption3(e.target.value);
        setText(e.target.value);
    }

    const onTextChange = (e) => {
        setText(e.target.value);
    }

    const onAndOrChange = (e, index) => {
        const values = [...andOr];
        values[index].AND_OR = e.target.value;
        setAndOr(values)
        // query.map((ele, i) => {
        //     if (i === index + 1) {
        //         ele.AND_OR = e.target.value
        //     }

        // })
        let data = query;
        data[index]['AND_OR'] = e.target.value

        setQuery(data)
    }

    // query table functions

    const leftChecked = intersection(checked, leftData);
    const rightChecked = intersection(checked, queryResult);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const numberOfChecked = (items) => intersection(checked, items).length;

    const handleToggleAll = (items) => () => {
        if (numberOfChecked(items) === items.length) {
            setChecked(not(checked, items));
        } else {
            setChecked(union(checked, items));
        }
    };

    const deleteLeftData =() =>{
        setLeftData(not(leftData, leftChecked));
        setChecked(not(checked, leftChecked));
    }

    const handleCheckedRight = () => {
        setQueryResult(queryResult.concat(leftChecked));
        setLeftData(not(leftData, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setLeftData(rightChecked.concat(leftData));
        setQueryResult(not(queryResult, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const postQuery_new = async (data,arrays) => {
        await axios.get(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/offlineevent`)
            .then(
                res => {
                    let array = [];
                    console.log('-',res.data.result.length)
                    if (res.data.result.length > 0) {
                        const data = res.data.result
                        console.log('res_data',res.data.result);
                        let newResultData = data.map((ele, i) => {
                            let obj = {
                                id: ele._id,
                                image: ele.image,
                                eventName: ele.eventName,
                                // varient: varientArray,
                                // defaultVarient: ""
                            }
                            return obj
                        })

                        let filterObj = newResultData.filter(qId => !mainData.some(o => o.id === qId.id))
                        console.log("==========",mainData,filterObj)
                        setQueryResult(filterObj)
                        
                    }
                    else{
                        cogoToast.error("No data Found");
                    }
                }
            ).catch(err => {
                console.log('error on this function',err)
                cogoToast.error("Bad Request Solr Error")
                setQueryResult([])
            })

    }

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(leftData);
        const [reorderItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem);

        setLeftData(items)


    }

    const handleVarintChange = (e, index) => {
        leftData.map((ele, i) => {

            if (i === index) {
                ele.defaultVarient = e.target.value
            }

        })
    }

    const right = (title, items) => (
        (items && items.length > 0 ?
            <Card>
                <CardHeader
                    className={classes.cardHeader}
                    avatar={
                        <Checkbox
                            onClick={handleToggleAll(items)}
                            checked={numberOfChecked(items) === items.length && items.length !== 0}
                            indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
                            disabled={items.length === 0}
                            inputProps={{ 'aria-label': 'all items selected' }}
                        />
                    }
                    title={title}
                    subheader={`${numberOfChecked(items)}/${items.length} selected`}
                />
                <Divider />
                <div className={classes.contentSearch}>
                    <div className={classes.searchIcon}>
                        <SearchIcon />
                    </div>
                    <InputBase
                        placeholder="Search…"
                        classes={{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        }}
                        value={searched}
                        onChange={(e) => setSearched(e.target.value)}
                        inputProps={{ 'aria-label': 'search' }}
                    />
                </div>

                <List className={classes.list} dense component="div" role="list">
                    {items.
                    filter(val => {
                        if (searched === "") {
                            return val
                        } else if (val.eventName.toLowerCase().includes(searched.toLowerCase())) {
                            return val
                        }
                    }).map((value) => {
                        const labelId = `${value._id}`;

                        return (
                            <ListItem key={value._id} role="listitem" button onClick={handleToggle(value)}>
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <img src={value.image ? 'https://images5.hungama.com/'+value.image[0] : NoImage} height="50" width="50" />


                                <ListItemText id={labelId} primary={value.eventName} />
                            </ListItem>
                        );
                    })}
                    <ListItem />
                </List>
            </Card> :
            <Card>
                <CardHeader
                    className={classes.cardHeader}
                    avatar={
                        <Checkbox
                            inputProps={{ 'aria-label': 'all items selected' }}
                        />
                    }
                    title={title}
                    subheader="no data"
                />
                <Divider />

                <List className={classes.list} dense component="div" role="list">
                    <p className="text-center">no data</p>
                    <ListItem />
                </List>
            </Card>)

    );


    const left = (title, items) => (
        <Card className={classes.Card}>
            <CardHeader
                className={classes.cardHeader}
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={items ? numberOfChecked(items) === items.length && items.length !== 0 : null}
                        indeterminate={items ? numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0 : null}
                        disabled={items ? items.length === 0 : null}
                        inputProps={{ 'aria-label': 'all items selected' }}
                    />
                }
                action={
                    <IconButton aria-label="delete" onClick={deleteLeftData} disabled={leftChecked.length === 0}>
                        <DeleteForeverOutlinedIcon className={leftChecked.length === 0?null:classes.btndelete}/>
                    </IconButton>
                }
                title={title}
                subheader={items ? `${numberOfChecked(items)}/${items.length} selected` : null}
            />
            <Divider />
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="contents" >
                    {(provided) => (
                        <List className={classes.list} dense component="div" role="list" {...provided.droppableProps} ref={provided.innerRef}>
                            {items ? items.map((value, index) => {
                                const labelId = `${value.id}`;
                                return (
                                    <Draggable key={value.id} draggableId={value.id} index={index}>
                                        {(provided) => (
                                            <ListItem role="listitem" button onClick={handleToggle(value)} {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        checked={checked.indexOf(value) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </ListItemIcon>
                                                <img src={value.image ? 'https://images5.hungama.com/'+value.image[0] : NoImage} height="50" width="50" />

                                                <ListItemText id={labelId}>
                                                <Grid container>
                                                        <Grid item md={6}>
                                                            <p className="mt-4 ml-1">{value.eventName}</p>
                                                        </Grid>
                                                        {/* <Grid item md={6}>
                                                            <FormControl variant="outlined" className={classes.formControl} style={{  minWidth: "50%" }}>
                                                            </FormControl>
                                                        </Grid> */}
                                                    </Grid>
                                                </ListItemText>
                                                {/* <img src={value.notExists == true ? value.image : NoImage} height="50" width="50" /> */}
                    
                                                {value.notExists ? <CloseIcon/> : ''}
                                            </ListItem>
                                        )}

                                    </Draggable>
                                );
                            }) : null}
                            {provided.placeholder}
                        </List>
                    )}
                </Droppable>
            </DragDropContext>

        </Card>
    );


    // end querytable functions
    const onSubmitquery = () => {
        const values = [...andOr]
        values.push({AND_OR:''})
        setAndOr(values)
        setQuery([...query, { "AND_OR": "", "field": option1, "operators": option2, "text": text }]);
    }


    const toggle = () => setModal(!modal);



    const ondeleteQuery = (e) => {
        let filtervalue = query.filter((ele,i)=>{
            if(e===i){
                return i !== e
            }else {
                return ele
            }
        })

        setQuery(filtervalue)
        let filterAndOr = andOr.filter((ele,i)=>{
            return e !== i
        })
        setAndOr(filterAndOr)
        if(query.length === 0){
            setAndOr("")
        }
    }

    const bucketStyleChange = (e) => {
        setBucketStyle(e.target.value)
    }



    const updateBucketApi = async (data) => {

        const fd = new FormData();
        fd.append("type", data.type);
        fd.append("language", data.language);
        fd.append("contentType", data.contentType);
        fd.append("names", JSON.stringify(data.name));
        fd.append("enabled", data.enabled);
        fd.append("live_date_time", data.live_date_time);
        fd.append("expiry", data.expiry);
        fd.append("row", data.row);
        fd.append("size", data.size);
        fd.append("more", data.more);
        fd.append("bucketStyle", data.bucketStyle);
        fd.append("query", JSON.stringify(data.query));
        fd.append("queryData", JSON.stringify(data.queryData));
        // fd.append("tag", data.tag);
        fd.append("page", data.page);
        fd.append("magnification",data.magnification)
        fd.append('continueStatus',data.continueStatus)
        fd.append('proUser',data.proUser)
        fd.append('shortDescription',data.shortDescription)
        fd.append('url',data.url)
        for (let index = 0; index < data.tag.length; index++) {
            const element = data.tag[index];
            // fd.append(`tag[${index}]`, element)
            if(element != 'null'){
                fd.append(`tag[${index}]`, element)
            }
        }
        if(data.tag.length == 0){
            fd.append(`tag[]`,[])
        }
        data.deleteMedia.map((ele,i) => {
            fd.append(`deleteMedia[${i}]`, ele)
        });
        if(data.media != null){
            for (let index = 0; index < data.media.length; index++) {
                const element = data.media[index];
                if (typeof (element) !== 'string') {
                    fd.append('file', element)
                }
        }
    }
        
        
        await axios.put(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/${props.match.params.id}`, fd,
            { headers: { "Content-Type": "multipart/form-data" } })
            .then(
                res => {
                    if (res.status === 200) {
                        cogoToast.success("content updated Succesfully")
                        props.history.push('/listPaytmBucket')


                    }
                }
            ).catch(err => {
                console.log(err.response)
            })

    }

    const postQuery = async (data,arrays) => {

        await axios.post(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/query`, data)
            .then(
                res => {
                    let array = [];
                    if (res.data.length > 0) {
                        const data = res.data
                        let newResultData = data.map((ele, i) => {
                            if((ele.data.id).includes('playlist-')){
                                array.push((ele.data.id).replace('playlist-',''));
                                }
                                else if((ele.data.id).includes('artist-')){
                                    array.push((ele.data.id).replace('artist-',''));
                                }
                                else{
                                    array.push((ele.data.id)) 
                                }
                            let obj = {
                                id: ele.data.id,
                                image: ele.data.image,
                                title: ele.data.title,
                                varient: varientArray,
                                defaultVarient: ""
                            }
                            return obj
                        })
                        
                        let filterObj = newResultData.filter(qId => !leftData.some(o => o.id === qId.id))
                        setQueryResult(filterObj)
                        let NewArray = arrays.filter((x) => !array.includes(x))
                        if(NewArray.length > 0){
                        cogoToast.error(`${NewArray} No data Found`);
                        }
                    }
                    else{
                        cogoToast.error("No data Found");
                    }
                }
            ).catch(err => {
                console.log(err.response)
                cogoToast.error("Bad Request Solr Error")
                setQueryResult([])
            })

    }

    const postQuery2 = async (data) => {
        console.log('data',data);
        await axios.post(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/query`, data)
            .then(
                res => {
                    
                    if (res.data.length > 0 ) {
                        const data = res.data
                        let newResultData = data.map((ele, i) => {
                            let obj = {
                                id: ele.data.id,
                                image: ele.data.image,
                                title: ele.data.title,
                                varient: varientArray,
                                defaultVarient: ""
                            }
                            return obj
                        })
                        let newData = newResultData.map(ele => ele.id)
                        mainData = mainData.map(ele =>{
                                if(newData.indexOf(ele.id)>-1){
                                    ele.notExists = false
                                }
                                else{
                                    ele.notExists = true
                                }
                            return ele
                        })
                        setLeftData(mainData)
                        
                    }
                    else{
                        cogoToast.error("No data Found");
                    }
                }
            ).catch(err => {
                console.log(err.response)
                cogoToast.error("Bad Request Solr Error")
                setQueryResult([])
            })

    }
    // convert string to boolean
    var str2bool = (value) => {
        if (value && typeof value === "string") {
            if (value.toLowerCase() === "true") return true;
            if (value.toLowerCase() === "false") return false;
        }
        return value;
    }


    const onUpdate = () => {
        const QueryData = leftData.map((ele, i) => {
            let obj = {
                id: ele.id,
                eventName: ele.eventName,
                // varient: ele.defaultVarient,
                image: ele.image,
                sequence: i
            }
            return obj;
        })
        const obj = {
            "type": "eventBucket",
            "language": lang,
            "name": [{
                default:englishLang,
                hi: hindiLang,
                mr: marathiLang,
                en: englishLang,
                kn: kannadaLang,
                te: teluguLang,
                pa: punjabiLang,
                ta: tamilLang,
                gu: gujaratiLang,

                    or:odisaLang,
                    ur:urduLang,
                    bn:bengaliLang,
                    ml:malayalamLang,
                    si:sinhalaLang,
                    ar:arabicLang,
                    af:afganiLang,
                    bur:burmeseLang,
                    khm:khmerLang,
                    prs: dariLang,
                ps: pashtoLang,
                vi: vietnameseLang
            }],
            "media": media,
            "enabled": str2bool(initialValues.enable),
            "live_date_time": liveDate === null?'':liveDate,
            "expiry": expiryDate === null? '':expiryDate,
            "row": initialValues.row,
            "size": initialValues.size,
            "more": str2bool(initialValues.more),
            "bucketStyle": bucketStyle,
            "queryData": QueryData,
            "query": query,
            "tag": tag,
            "page": singlePage,
            "deleteMedia": deleteMediaList,
            "contentType":content,
            magnification:initialValues.magnification,
            "storeId": localStorage.getItem("storeId"),
            "continueStatus":str2bool(continueToggle),
            "url":initialValues.url,
            "shortDescription":initialValues.shortDescription,
            "proUser":initialValues.proUser

        }
        updateBucketApi(obj)
    }
    const handleChangeToggle = (e) =>{
        console.log('ee',e)
        setcontinueToggle(e)
    }
    const handleproToggle = (e) =>{
        console.log('ee',e)
        setproToggle(e)
    }

    const onSerachQuery = async () => {
        let array;
        const obj = query.map(ele => {
            let newQuery = {
                "AND_OR": ele.AND_OR,
                "field": ele.field.value,
                "operators": ele.operators.toString().replace(' ', '_').toLowerCase(),
                "text": ele.text.value ? ele.text.Description :ele.text.Description ? ele.text.typeid : ele.text

            }
            return newQuery
        })
        let newObj = {
            'query': obj,
            "storeId":localStorage.getItem("storeId"),
            "type":content
        }
        array = (query[1].text).split(',')
        console.log('query====>',obj);
    //   await postQuery(newObj,array);
    }

    const onSerachQuery2 = async (query,type) => {
        console.log('query',query,type)
        const obj = query.map(ele => {
            let newQuery = {
                "AND_OR": ele.AND_OR,
                "field": ele.field.value,
                "operators": ele.operators.toString().replace(' ', '_').toLowerCase(),
                "text": ele.text.value ? ele.text.Description :ele.text.Description ? ele.text.typeid : ele.text

            }
            return newQuery
        })
        let newObj = {
            'query': obj,
            "storeId":localStorage.getItem("storeId"),
            "type":type
        }
        console.log('query2====>',newObj);
    //    postQuery2(newObj);
    }

    const onClear = () => {
        setInitialValues(initialState);
        setQueryResult([]);
        setQuery([]);
        setHindiLang("");
        setMarathiiLang("");
        setKannadaLang("");
        setTeluguLang("");
        setPunjabiLang("");
        setTamilLang("");
        setGujaratiLang("");
        setMedia("");
        setTag([])
        setLeftData([]);
        setText("");
        setOption3("");
        setBucketStyle("");
        setLiveDate(null);
        setExpiryDate(null)

    }
    const deleteImg = (e, i, ele) => {
        let newArray = media.filter((ele, index) => {
            return index !== i;
        })
        // let newMedia = [];
        setDeleteMediaList([...deleteMediaList, ele]);

        setMedia(newArray)
    }


    return (
        <Fragment>
            <Paper component={Box} p={4}>
                <div >
                    <h1 className="m-3 text-center">Edit Bucket</h1>
                    <Grid container >
                        <BucketForm
                            onHandleChangeData={onHandleChangeData}
                            initialValues={initialValues}
                            medialHandle={medialHandle}
                            toggle={toggle}
                            bucketStyle={bucketStyle}
                            bucketStyleChange={bucketStyleChange}
                            pages={pages}
                            singlePage={singlePage}
                            handlePageChange={handlePageChange}
                            liveDate={liveDate}
                            expiryDate={expiryDate}
                            onLiveDateChange={onLiveDateChange}
                            onexpiryDateChange={onexpiryDateChange}
                            tag={tag}
                            handleTagChange={handleTagChange}
                            MenuProps={MenuProps}
                            radioList={radioList}
                            langList={langList}
                            lang={lang}
                            handleChangeLang={handleChangeLang}
                            media={media}
                            deleteImg={deleteImg}
                            bucketSTyleList={bucketSTyleList}
                            content={content}
                            handleContentChange={handleContentChange}
                            content_type={localStorage.getItem("userRole") != "SuperAdmin" ? content_type : game_content_type}
                            setEnglishLang={setEnglishLang}
                            englishLang = {englishLang}
                            handleChangeToggle = {handleChangeToggle}
                            continueToggle ={continueToggle}
                            setcontinueToggle = {setcontinueToggle}
                            handleproToggle = {handleproToggle}
                            proToggle ={proToggle}
                            setproToggle = {setproToggle}
                        />

                        <Grid container alignItems="center" className={classes.root}>

                            <Grid item md={5}>
                                <h4>Selected Content Data</h4>
                                {left('Choices', leftData)}</Grid>
                            <Grid item md={2}>
                                <Grid container direction="column" alignItems="center">
                                    <Button
                                        style={{ margin: "5px" }}
                                        variant="outlined"
                                        size="small"
                                        className={classes.button}
                                        onClick={handleCheckedRight}
                                        disabled={leftChecked.length === 0}
                                        aria-label="move selected right"
                                    >
                                        &gt;
                                    </Button>
                                    <Button
                                        style={{ margin: "5px" }}

                                        variant="outlined"
                                        size="small"
                                        className={classes.button}
                                        onClick={handleCheckedLeft}
                                        disabled={rightChecked.length === 0}
                                        aria-label="move selected left"
                                    >
                                        &lt;
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid item md={5}><h4>Content Data</h4>{right('Choices', queryResult)}


                            </Grid>
                        </Grid>

                        <Grid item md={12}>
                            <Button className="m-4" variant="contained" color="primary" onClick={onUpdate}>Update</Button>
                            {/* <Button variant="contained" color="secondary" onClick={onClear}>Clear</Button> */}

                        </Grid>

                    </Grid>

                    <MultiLanguageModal modal={modal}
toggle={toggle}
englishLang={englishLang}
    hindiLang={ hindiLang}
    marathiLang={ marathiLang}
    kannadaLang={ kannadaLang}
    teluguLang={ teluguLang}
    punjabiLang={ punjabiLang}
    tamilLang={ tamilLang}
    gujaratiLang={ gujaratiLang}

    malayalamLang={ malayalamLang}
    bengaliLang={ bengaliLang}
    odisaLang={ odisaLang}
    urduLang={ urduLang}
    sinhalaLang={sinhalaLang}
    khmerLang = {khmerLang}
    arabicLang = {arabicLang}
    burmeseLang ={burmeseLang}
    afganiLang ={afganiLang}
     dariLang ={dariLang}
    pashtoLang ={pashtoLang}
    setPashtoLang ={setPashtoLang}
    vietnameseLang ={vietnameseLang}
    setVietnameseLang ={setVietnameseLang}
    setDariLang ={setDariLang}
    setAfganiLang ={setAfganiLang}
    setBurmeseLang ={setBurmeseLang}
    setEnglishLang = {setEnglishLang}
    setHindiLang= {setHindiLang}
    setMarathiiLang= {setMarathiiLang}
    setKannadaLang={setKannadaLang}
    setTeluguLang={setTeluguLang}
    setPunjabiLang={setPunjabiLang}
    setTamilLang={setTamilLang}
    setGujaratiLang={setGujaratiLang}
    setOdisaLang={setOdisaLang}
    setMalayalamLang={setMalayalamLang}
    setBengaliLang={setBengaliLang}
    setUrduLang={setUrduLang}
    setSinhalaLang = {setSinhalaLang}
    setKhmerLang = {setKhmerLang}
    setArabicLang = {setArabicLang}
>
    
</MultiLanguageModal>
                   
                </div>
            </Paper>

        </Fragment>
    )
}
